import { Environment } from "./environment.class";

export const environment = new Environment(true,
  'https://api.develop.mosterd.com',
  'login.develop.rulebooks.nl',
  '5zpghu11GLFrx95eg5jMl1f0BEnkIenF',
  'https://api.mosterd'
    );
